import { t } from "@lingui/macro";
import { motion } from "framer-motion";

const stats = () => [
  { value: "6M+", label: t`Job seekers trust Stylion` },
  { value: "96%", label: t`ATS pass rate` },
  { value: "2 min", label: t`Average resume build time` },
  { value: "11", label: t`Specialized AI agents` },
];

export const TrustBarSection = () => {
  const items = stats();

  return (
    <section
      id="trust-bar"
      className="relative border-y border-[#3e3431]/10 bg-white py-12"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4 lg:gap-12">
          {items.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.06 }}
              className="text-center"
            >
              <div className="font-serif text-4xl font-extrabold tracking-tight text-[#3e3431] sm:text-5xl">
                {stat.value}
              </div>
              <div className="mt-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#D97757]">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
